<nav class="navbar navbar-expand-lg fixed-top bg-primary navbar-dark">
  <div class="container-fluid position-relative">
    <!-- Left: Brand -->
    <a class="navbar-brand m-0">
      <img src="../../../../assets/img/nashlogo.jpg" alt="Logo" width="120" />
    </a>

    <!-- Center: Title -->
    <div class="position-absolute top-50 start-50 translate-middle text-white fw-semibold pointer-events-none text-center navbar-title">
      <span class="d-none d-sm-inline-block fs-3">NASH Pro</span>
    </div>

    <!-- Right: Toggler -->
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarContent"
      aria-controls="navbarContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Right: Menus -->
    <div class="collapse navbar-collapse" id="navbarContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0 gap-3">
        <!-- Release Notes -->
        <li class="nav-item d-flex align-items-center">
          <button type="button" class="whats-new-btn d-flex align-items-center gap-2" (click)="openReleaseNotes()">
            <span class="whats-new-icon">
              <img src="assets/icons/whats-new.svg" alt="" width="18" height="18" />
              <span class="whats-new-dot"></span>
            </span>
            <span>{{ 'HEADER.WHATS_NEW' | translate }}</span>
          </button>
        </li>
        <!-- Language -->
        <li class="nav-item dropdown d-flex align-items-center">
          <a
            class="nav-link dropdown-toggle text-dark bg-secondary d-flex align-items-center justify-content-between px-3 language-dropdown-toggle"
            href="#"
            id="languageDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ selectedLang | uppercase }}
          </a>
          <ul class="dropdown-menu ng-secondary dropdown-menu-end text-dark w-75" aria-labelledby="languageDropdown">
            @for (lang of languages; track lang) {
              <li>
                <button class="dropdown-item" type="button" (click)="switchLanguage(lang)">
                  @if (lang === 'en') {
                    English
                  }
                </button>
              </li>
            }
          </ul>
        </li>

        <!-- Profile (mobile) -->
        <li class="nav-item d-lg-none">
          <a class="nav-link" (click)="toggleProfile()">
            <img class="profile-image" src="assets/img/default_profile.svg" alt="Profile" />
          </a>
          <ul class="dropdown-menu dropdown-menu-end w-75" [class.show]="isProfileMenuOpen">
            <li>
              <div class="dropdown-item">
                <img class="profile-image-icon me-2" src="assets/img/default_profile.svg" alt="Profile Icon" />
                <div class="profile-details">
                  <span>{{ username }}</span>
                  <span>{{ email }}</span>
                </div>
              </div>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button class="dropdown-item" (click)="logout()">{{ 'LOGOUT' | translate }}</button>
            </li>
          </ul>
        </li>

        <!-- Profile (desktop) -->
        <li class="nav-item dropdown d-none d-lg-block">
          <a
            class="nav-link dropdown-toggle m-0 p-0 d-flex align-items-center"
            href="#"
            id="profileDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            <img class="profile-image" src="assets/img/default_profile.svg" alt="Profile" />
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
            <li>
              <div class="dropdown-item d-flex align-items-center">
                <img class="profile-image-icon me-2" src="assets/img/default_profile.svg" alt="Profile Icon" />
                <div class="profile-details">
                  <span>{{ username }}</span>
                  <span>{{ email }}</span>
                </div>
              </div>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button class="dropdown-item" (click)="logout()">{{ 'LOGOUT' | translate }}</button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
